import { createEntityAdapter, createSlice } from "@reduxjs/toolkit";
import { getWorkspaceDetails } from "store/organization/action";

import { getMyProfile } from "../user/actions";
import {
  getMeWorkspaces,
  getWorkspaceAssignableUsers,
  getWorkspaceDetailsOfOrganization,
  getWorkspaces,
  getWorkspacesByCategory,
  getWorkspaceUsers,
} from "./action";

export const workspaceEntityAdapter = createEntityAdapter({
  selectId: (entity) => entity.workspaceId,
});

const initialState = workspaceEntityAdapter.getInitialState({
  workspacesDetails: [],
  totalOrganizationWorkspaces: 0,
  workspacesByOrganizationId: [],
  filteredWorkspaces: [],
  totalFilteredWorkspaces: 0,
});

export const workspaceSlice = createSlice({
  name: "workspace",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getWorkspaces.fulfilled, (state, action) => {
      state.workspacesDetails = action.payload.workspaces;
      state.totalOrganizationWorkspaces = action.payload.total;
    });
    builder.addCase(getMyProfile.fulfilled, (state, action) => {
      if (action.payload.entities?.workspace) {
        state.entities = {
          ...state.entities,
          ...action.payload.entities.workspace,
        };
        state.ids = Object.keys(action.payload.entities.workspace);
      }
    });
    builder.addCase(getWorkspaceDetailsOfOrganization.fulfilled, (state, action) => {
      if (action.payload.entities?.workspace) {
        const updatedEntities = Object.keys(action.payload.entities.workspace).reduce(
          (acc, key) => ({
            ...acc,
            [key]: {
              ...state.entities[key],
              ...action.payload.entities.workspace[key],
            },
          }),
          state.entities,
        );

        state.entities = {
          ...action.payload.entities.workspace,
          ...updatedEntities,
        };
        state.workspacesByOrganizationId = action.payload.entities.workspace;
      }
    });
    builder.addCase(getWorkspaceUsers.fulfilled, (state, action) => {
      if (action.payload.status) {
        const workspaceId = action.meta.arg.payload.workspaceId;
        if (state.entities[workspaceId]) {
          state.entities[workspaceId].workspaceUsers = action.payload?.users;
          state.entities[workspaceId].totalUsers = action.payload?.total;
        } else {
          const { users } = action.payload;

          const newWorkspace = {
            workspaceId: workspaceId,
            organizationId: "",
            users: users || [],
            displayName: "",
            logo: "",
            workspaceUsers: users || [],
            totalUsers: users ? users.length : action.payload?.total,
            assignableUsers: [],
            organization: {},
          };

          workspaceEntityAdapter.addOne(state, newWorkspace);
          state.totalOrganizationWorkspaces += 1;
        }
      }
    });
    builder.addCase(getWorkspaceAssignableUsers.fulfilled, (state, action) => {
      const workspaceId = action.meta.arg.entityId;

      if (workspaceId) {
        state.entities[workspaceId] = state.entities[workspaceId] ?? {};

        if (workspaceId && state.entities[workspaceId]) {
          if (action.meta.arg.upsert) {
            const existingUsers = state.entities[workspaceId].assignableUsers || [];
            const newUsers = action.payload?.users || [];

            const userMap = new Map(existingUsers.map((user) => [user.userId, user]));

            newUsers.forEach((user) => userMap.set(user.userId, user));

            state.entities[workspaceId].assignableUsers = Array.from(userMap.values());
          } else {
            state.entities[workspaceId].assignableUsers = action.payload?.users;
          }
        }

        state.entities[workspaceId].totalAssignableUsers = action.payload?.total || 0;
      }
    });
    builder.addCase(getWorkspaceDetails.fulfilled, (state, action) => {
      const entityId = action.meta.arg.entityId;
      if (entityId && state.entities[entityId]) {
        state.entities[entityId].displayName = action.payload?.workspace?.displayName;
        state.entities[entityId].organizationId = action.payload?.workspace?.organizationId;
        state.entities[entityId].logo = action.payload?.workspace?.logo;
        state.entities[entityId].organization = action.payload?.organization;
      }
    });
    builder.addCase(getWorkspacesByCategory.fulfilled, (state, action) => {
      state.workspacesDetails = action.payload.workspaces;
    });
    builder.addCase(getMeWorkspaces.fulfilled, (state, action) => {
      if (action.payload.status) {
        if (action.meta.arg.payload.params.page === 1) {
          state.filteredWorkspaces = action.payload.data;
        } else {
          // upsert
          const newWorkspaces = [...state.filteredWorkspaces, ...action.payload.data];
          const newWorkspacesMap = new Map(newWorkspaces.map((workspace) => [workspace.workspaceId, workspace]));

          state.filteredWorkspaces = Array.from(newWorkspacesMap.values());
        }
        state.totalFilteredWorkspaces = action.payload.total;
      }
    });
  },
});

export default workspaceSlice.reducer;
